import { render, staticRenderFns } from "./ObstacleModal.vue?vue&type=template&id=80437fca&scoped=true&"
import script from "./ObstacleModal.vue?vue&type=script&lang=js&"
export * from "./ObstacleModal.vue?vue&type=script&lang=js&"
import style0 from "./ObstacleModal.vue?vue&type=style&index=0&id=80437fca&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80437fca",
  null
  
)

export default component.exports